import { createBrowserRouter } from "react-router-dom";
import { Navigate } from "react-router-dom";

import GuestLayout from "./layouts/guest.layout";

import Login from "./screens/login.screen";
import DrawerApp from "./components/drawer.component";
import ProductsScreen from "./screens/products.screen";
import CategoriesScreen from "./screens/categories.screen"
import GroupsScreen from "./screens/groups.screen";
import PlatformsScreen from "./screens/platforms.screen";
import UsersScreen from "./screens/users.screen";
import CustomerProfileScreen from "./screens/customerProfile.screen";
import StoreDetailsScreen from "./screens/storeDetails.screen";
import LicenseDetails from "./screens/licenseDetails.screen";
import RegisterScreen from "./screens/register.screen";
import InsertFirstDetailsScreen from "./screens/insertFirstDetails.screen";
import AddStoreScreen from "./screens/addStore.screen";
import AddCompanyScreen from './screens/addCompany.screen';
import VatsScreen from "./screens/vats.screen";
import PaymentMethodsScreen from "./screens/paymentMethods.screen";
import SystemSettingsScreen from "./screens/systemSettings.screen";
import ReportsScreen from "./screens/reports.screen";
import ViewGridScreen from "./screens/viewGrid.screen";
import ReviewScreen from "./screens/review.screen";

const router = createBrowserRouter([
  {
    path: "*",
    element: <div>Not found</div>,
  },
  {
    path: "/",
    element: <DrawerApp />,
    children: [
      {
        path: "/",
        element: <Navigate to="/insert-details" />,
      },
      {
        path: "/products",
        element: <ProductsScreen/>
      },
      {
        path: "/categories",
        element: <CategoriesScreen/>
      },
      {
        path: "/groups",
        element: <GroupsScreen/>
      },
      {
        path: "/platforms",
        element: <PlatformsScreen/>
      },
      {
        path: "/payments",
        element: <PaymentMethodsScreen/>
      },
      {
        path: "/users",
        element: <UsersScreen/>
      },
      // {
      //   path: "/profile",
      //   element: <CustomerProfileScreen/>
      // },
      {
        path: "/store-details",
        element: <StoreDetailsScreen/>
      },
      {
        path: "/license",
        element: <LicenseDetails/>
      },
      {
        path: "/insert-details",
        element: <InsertFirstDetailsScreen/>
      },
      {
        path: "/company",
        element: <AddCompanyScreen/>
      },
      {
        path: "/store",
        element: <AddStoreScreen/>
      },
      {
        path: "/vats",
        element: <VatsScreen/>
      },
      {
        path: "/system-settings",
        element: <SystemSettingsScreen/>
      },
      {
        path: "/reports",
        element: <ReportsScreen/>
      },
      {
        path: "/view-grid",
        element: <ReviewScreen/>
      },
    ],
  },
  {
    path: "/",
    element: <GuestLayout />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/register",
        element: <RegisterScreen/>
      }
    ],
  },
]);

export default router;